import { render, staticRenderFns } from "./game-frame.vue?vue&type=template&id=7acbe843&scoped=true&"
import script from "./game-frame.ts?vue&type=script&lang=ts&"
export * from "./game-frame.ts?vue&type=script&lang=ts&"
import style0 from "./game-frame.scss?vue&type=style&index=0&id=7acbe843&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7acbe843",
  null
  
)

component.options.__file = "game-frame.vue"
export default component.exports